import React, {useContext, useEffect, useState} from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    InputAdornment,
    InputLabel,
    Link,
} from "@material-ui/core";
import Dropzone from 'react-dropzone';

import Input from "@material-ui/core/Input";
import {useStores} from "../../../../../hooks";
import {observer} from "mobx-react";
import {localize,} from "../../../../../common/libs";
import {DeliveryConditionType, DeliveryType, IDeliveryConditionsZonePrice} from "../../../../../services/menu/models";
import OrderSettingsPageStoreContext from "../context";
import {useTranslation} from "react-i18next";
import {CircularProgress, Typography} from "../../../../../common/components/libs";
import {uploadFile} from "../../../../../services/files";
import {SnackbarType} from "../../../../../stores/common";
import styles from "../../menuEditor/style.module.css";
import {Plus as AddIcon} from "react-feather";
import {ExecutionStatus} from "../../../../../services/general/requestsResponses";


const EditDeliveryZonesForm = () => {
    const {t} = useTranslation(["general", "menu"]);

    const {generalStore} = useStores();
    const [isUploadInProgress, setIsUploadInProgress] = useState(false);

    const store = useContext(OrderSettingsPageStoreContext);
    const open = store.forms.editDeliveryZones;
    const deliveryConditions = store.deliverySettings[DeliveryType.toAddress].deliveryConditions;

    useEffect(() => {
        if (deliveryConditions.type !== DeliveryConditionType.zonePrice) return;
        if (deliveryConditions.type === DeliveryConditionType.zonePrice) {
            store.setDeliveryZones(deliveryConditions.deliveryZones)
        }

    }, [deliveryConditions]);


    const uploadZones = async (file: File) => {
        setIsUploadInProgress(true);

        try {
            const res = await uploadFile(file, "zonesType");
            if (res.executionStatus === ExecutionStatus.Finished) {
                store.setDeliveryZones(res.deliveryConditions.deliveryZones);
                generalStore.showSnackbar({
                    title: t("general:success"),
                    description: "Зоны доставки загружены успешно",
                    type: SnackbarType.success
                })
            }
        } catch (e) {
            generalStore.showSnackbar({
                title: t("general:error"),
                description: "Не получилось загрузить зоны доставки",
                type: SnackbarType.error
            })
        } finally {
            setIsUploadInProgress(false);
        }
        return;
    };

    const onDrop = async (files: File[]) => {
        await uploadZones(files[0]);
    };

    let zonesBlockContent = [];

    if (!isUploadInProgress) {
        zonesBlockContent.push(
            <Dropzone onDrop={onDrop} key="cmif_1s">
                {({getRootProps, getInputProps}) => (
                    <div {...getRootProps({className: styles.dropzone})}
                         style={{maxHeight: "30px", maxWidth: "100px"}}>
                        <input {...getInputProps()} />
                        <AddIcon size={30}/>
                        {
                            (store.deliveryZones[0] && store.deliveryZones[0].coordinates.length > 0) ?
                                <span>{t("general:replace")}</span> :
                                <span>{t("general:load")}</span>
                        }
                    </div>
                )}
            </Dropzone>
        )
    } else if (isUploadInProgress) {
        zonesBlockContent.push(
            <div
                key="cmif_3"
                style={{
                    minHeight: "200px",
                    minWidth: "200px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}
            >
                <CircularProgress
                    m={2}
                    color="secondary"
                />
            </div>
        )
    }


    const closeForm = () => {
        store.closeDeliveryZonesForm();
    };

    const handleSubmit = async () => {
        if (deliveryConditions) {
            const data: IDeliveryConditionsZonePrice = {
                deliveryZones: store.deliveryZones,
                type: DeliveryConditionType.zonePrice
            };
            store.setDeliveryToAddressSettings({
                description: localize(store.deliverySettings[DeliveryType.toAddress].description),
                deliveryConditions: data,
                isEnabled: store.deliverySettings[DeliveryType.toAddress].isEnabled,
            })

        }
        closeForm();
    };

    const checkNumbers = (inputValue: string) => {
        return /^s?\d{1,9}$/.test(inputValue)
    }

    return (
        <Dialog
            open={open}
            onClose={closeForm}
            aria-labelledby="form-dialog-title"
            fullWidth={true}
            maxWidth={"sm"}
        >
            <DialogTitle id="form-dialog-title">
                {t("menu:deliveryZones.deliveryZonesSettings")}
            </DialogTitle>
            <DialogContent style={{
                lineHeight: "5"
            }}>
                <Typography>

                    1. {t("menu:deliveryZones.goToZoneConstructor")} -{">"}
                </Typography>
                <Typography>
                    2. {t("menu:deliveryZones.polygons")} -{">"}
                </Typography>
                <Typography>
                    3. {t("menu:deliveryZones.contour")} -{">"}
                </Typography>
                <Typography>
                    4. {t("menu:deliveryZones.getZoneName")}.
                </Typography>
                <Typography>
                    5. {t("menu:deliveryZones.continue")} -{">"} {t("menu:deliveryZones.export")}
                    -{">"} GEOJSON -{">"} {t("general:download")}
                </Typography>
                <div className={styles.constructorLink}>
                    <Link href="https://yandex.ru/map-constructor/" color="primary" target="_blank">
                        {t("menu:deliveryZones.zoneConstructor")}
                    </Link>
                </div>

                <div className={styles.downloadJSON}>
                    <Typography>
                        6.   {t("menu:deliveryZones.download")}
                    </Typography>
                    <div>{zonesBlockContent}</div>
                </div>

                <br/>

                {
                    store.deliveryZones.map((zone, index) => {
                        return (
                            <form autoComplete="off">
                                <FormControl fullWidth>
                                    <InputLabel>{t("menu:deliveryZones.zoneName")}</InputLabel>
                                    <Input
                                        key={index}
                                        value={zone.name}
                                        onChange={(event) => {
                                            store.updateZoneNameByIndex(index, event.target.value);
                                        }}
                                    />
                                </FormControl>

                                <FormControl fullWidth>
                                    <InputLabel>{t("menu:orderSettingsPage.deliveryPrice")}</InputLabel>
                                    <Input
                                        key={index}
                                        value={ zone.fixedDeliveryPrice===null ? "" : zone.fixedDeliveryPrice.price/100}
                                        onChange={(event) => {
                                            if (checkNumbers(event.target.value)) {
                                                store.updateZoneFixedPriceByIndex(index, event.target.value);
                                            } else  store.updateZoneFixedPriceByIndex(index, "");
                                        }}
                                        startAdornment={
                                            <InputAdornment position="start"> ₽ </InputAdornment>
                                        }
                                    />
                                </FormControl>
                                <FormControl fullWidth>
                                    <InputLabel>{t("menu:orderSettingsPage.minPriceToFreeDelivery")}</InputLabel>
                                    <Input
                                        value={zone.freeDeliveryMinimalOrderPrice === null ? "" : zone.freeDeliveryMinimalOrderPrice.price / 100}
                                        onChange={(event) => {
                                            if (checkNumbers(event.target.value)) {
                                                store.updateZoneFreeDeliveryMinimalOrderPriceByIndex(index, event.target.value);
                                            } else {
                                                store.updateZoneFreeDeliveryMinimalOrderPriceByIndex(index, "");
                                            }
                                        }}
                                        startAdornment={
                                            <InputAdornment position="start"> ₽ </InputAdornment>
                                        }
                                    />
                                </FormControl>

                            </form>
                        )
                    })
                }
            </DialogContent>

            <DialogActions>
                <Button onClick={closeForm} color="primary">
                    {t("general:cancel")}
                </Button>
                <Button
                    color="primary"
                    onClick={handleSubmit}
                >
                    {t("general:save")}
                </Button>
            </DialogActions>
        </Dialog>
    );

};

export default observer(EditDeliveryZonesForm);
